const tables = {
    EN: {
        loading: 'Loading...',
        pageText: 'Page',
        nextText: 'Next',
        previousText: 'Previous',
        rowsText: 'rows',
        noDataText: 'No data to show',
        usersList: 'Users list',
        addUser: 'Add user',
        blockUser: 'Block user',
        unblockUser: 'Unblock user',
        carsList: 'Cars list',
        add_order: 'Add Order',
        edit_order: 'Edit Order',
        set_installation_date: 'Set installation date',
        edit_installation_date: 'Edit installation date',
        cancel_installation_date: 'Cancel installation date',
        generate_assembly_report: 'Generate assembly report',
        cancel_order: 'Cancel Order',
        confirm_order: 'Confirm Order',
        car_damage_inside: "Car Damage Inside",
        car_damage_outside: "Car Damage Outside",
        car_has_damage: "Car Has Damage",
        dashboard_has_errors: "Dashboard has errors",
        incompatible_vin: "Incompatible  VIN",
        created_by: "Created by",
        by: 'by',
        details: 'Details',
        confirm_installation: 'Confirm installation',
        resetPassword: 'Reset password',
        installation_comment: 'Installation comment',
        AUTOMATIC: 'Automatic',
        MANUAL: 'MANUAL',
        ACTIVE: 'Active',
        NOT_ACTIVE: 'Not active',
    },
    PL: {
        loading: 'Ładowanie...',
        pageText: 'Strona',
        nextText: 'Następna',
        previousText: 'Poprzednia',
        rowsText: 'wierszy',
        noDataText: 'Brak danych do wyświetlenia',
        usersList: 'Lista użytkowników',
        addUser: 'Dodaj użytkownika',
        blockUser: 'Zablokuj użytkownika',
        unblockUser: 'Odblokuj użytkownika',
        carsList: 'Lista pojazdów',
        add_order: 'Dodaj zlecenie',
        edit_order: 'Edytuj zlecenie',
        set_installation_date: 'Ustal datę instalacji',
        edit_installation_date: 'Zmień datę instalacji',
        cancel_installation_date: 'Anuluj zaplanowany montaż',
        generate_assembly_report: 'Wygeneruj protokół montażu',
        cancel_order: 'Anuluj zlecenie',
        confirm_order: 'Zatwierdź zlecenie',
        car_damage_inside: "Uszkodzony w środku",
        car_damage_outside: "Uszkodzony na zewnątrz",
        car_has_damage: "Uszkodzony samochód",
        dashboard_has_errors: "Błędy na desce rozdzielczej",
        incompatible_vin: "Niezgodny VIN",
        created_by: "Utworzono przez",
        by: 'przez',
        details: 'Szczegóły',
        confirm_installation: 'Potwierdź instalację',
        resetPassword: 'Resetuj hasło',
        installation_comment: 'Komentarz do instalacji',
        AUTOMATIC: 'Automatyczny',
        MANUAL: 'Manualny',
        ACTIVE: 'Aktywny',
        NOT_ACTIVE: 'Nieaktywny',

    }
};

export default tables;



// WEBPACK FOOTER //
// ./src/Translations/Tables.ts